<template>
  <div class="newsboard-wrapper">
    <h2 class="subtitle">Obavijesti</h2>
    <div>
      <p class="notification" v-for="notification in news" :key="notification.id">{{ notification.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Newsboard',
  props: {
    news: Array,
  },
};
</script>

<style scoped>
.newsboard-wrapper {
  max-width: 450px;
  margin-bottom: 50px;
}

.subtitle {
  font-weight: 800;
  font-size: 24px;
  line-height: 36px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 16px;
}

.notification {
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0;
}

.notification:not(:last-child) {
  margin-bottom: 16px;
}
</style>
